import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { calculateLotQty, defaultKSK2110_R01Filter, KSK2110_R01Filter, useKSK2110_R01Store } from './Store_KSK2110_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import useUiuxStore, { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteKSK2110_R01, downloadExcel_KSK2110_R01, getKSK2110_R01AllCount, getKSK2110_R01LotList, getKSK2110_R01InspectList, getKSK2110_R01List, getKSK2110_R01ProductResultList, patchKSK2110_R01, postKSK2110_R01, printKSK2110_R01, getKSK2110_R01DetailList, getKSK2110_R01DetailStockList, getKSK2110_R01TransportedInfo, getKSK2110_R01One, getKSK2110_R01LotSearch, patchKSK2110_R01WorkStart, patchKSK2110_R01WorkEnd, createKSK2110_R01LotNo } from "./Api_KSK2110_R01";
import { defaultKSK2110_R01LotDto, defaultKSK2110_R01HeaderDto, defaultKSK2110_R01InspectDto, KSK2110_R01LotDto, KSK2110_R01Dto, KSK2110_R01HeaderDto, KSK2110_R01InspectDto, KSK2110_R01ProductResultDto, defaultKSK2110_R01DetailDto, KSK2110_R01DetailDto, defaultKSK2110_R01LotSearchDto, KSK2110_R01WorkTimeProcessType, mapKioskWorkTimes } from './Dto_KSK2110_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	KSK2020_R01_BAD_WAREHOUSE_MESSAGE,
	KSK2020_R01_OUT_WAREHOUSE_MESSAGE,
	KSK2020_R01_PRODUCT_WAREHOUSE_MESSAGE,
	KSK2110_R01_HEADER_ROW_VALIDATE,
	KSK2110_R01_INSPECT_ROW_VALIDATE,
	KSK2110_R01_LOT_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';
import { formatDate, toLocalDateTime, validateString } from 'src/utils/string/stringUtil';
import { validateEmployeeCd } from 'src/utils/grid/GridValidateContent';
import { defaultValidateDateString, inkoNpmOption } from 'src/components/common/common';
import { AxiosError } from 'axios';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { getProductOrderPopupList } from 'src/apis/productOrderApi';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import useUserStore from 'src/store/useUserStore';
import { LabelPrintData } from 'src/apis/labelApi';
import { useQzPrint } from 'src/hooks/useQzPrint';
import { KSK2110_R01_extractUnprintedLabelData } from './labelDataBuilder_KSK2110_R01';

interface Props {
	gridRef: React.RefObject<AgGridReact<KSK2110_R01HeaderDto> | null>;
	lotGridRef: React.RefObject<AgGridReact<KSK2110_R01LotDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<KSK2110_R01DetailDto> | null>;
	inspectGridRef: React.RefObject<AgGridReact<KSK2110_R01InspectDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_KSK2110_R01 = (props: Props) => {

	const {
		gridRef, lotGridRef, detailGridRef, inspectGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { faultyValueList, itemStatusList, moneyCdList, vatTypeList, compCdList, wmsCdList, employeeCdList, workPlaceList, warehouseCdList, itemCdMap } = useCommonCodeStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { productWorkNavigationData, setProductWorkNavigationData, setOrderNavigationData, addTabList, setActiveTab } = useUiuxStore();

	
	const {
		KSK2110_R01Filter, setKSK2110_R01Filter,
		KSK2110_R01PastFilter, setKSK2110_R01PastFilter,
		KSK2110_R01List, setKSK2110_R01List,
		editKSK2110_R01, setEditKSK2110_R01,
		// selectedKSK2110_R01, setSelectedKSK2110_R01, 
		deletedKSK2110_R01LotList, setDeletedKSK2110_R01LotList, addDeletedKSK2110_R01LotList, removeDeletedKSK2110_R01LotList, 
		selectedKSK2110_R01LotList, setSelectedKSK2110_R01LotList, addSelectedKSK2110_R01LotList, removeSelectedKSK2110_R01LotList,
		KSK2110_R01LotList, setKSK2110_R01LotList, insertKSK2110_R01LotList,
		originalKSK2110_R01LotList, setOriginalKSK2110_R01LotList,
		deletedKSK2110_R01DetailList, setDeletedKSK2110_R01DetailList, addDeletedKSK2110_R01DetailList, removeDeletedKSK2110_R01DetailList, 
		selectedKSK2110_R01DetailList, setSelectedKSK2110_R01DetailList, addSelectedKSK2110_R01DetailList, removeSelectedKSK2110_R01DetailList,
		KSK2110_R01DetailList, setKSK2110_R01DetailList, insertKSK2110_R01DetailList,
		originalKSK2110_R01DetailList, setOriginalKSK2110_R01DetailList,
		KSK2110_R01InspectList, setKSK2110_R01InspectList, insertKSK2110_R01InspectList,
		deletedKSK2110_R01InspectList, setDeletedKSK2110_R01InspectList, addDeletedKSK2110_R01InspectList, removeDeletedKSK2110_R01InspectList,
		selectedKSK2110_R01InspectList, setSelectedKSK2110_R01InspectList, addSelectedKSK2110_R01InspectList, removeSelectedKSK2110_R01InspectList,
		originalKSK2110_R01InspectList, setOriginalKSK2110_R01InspectList,
		KSK2110_R01LotSearch, setKSK2110_R01LotSearch,
		allCount, setAllCount,
		notProductResult, setNotProductResult,
		modalVisible, setModalVisible,
		workTimeModalVisible, setWorkTimeModalVisible,
		workTimeModalType, setWorkTimeModalType,
		initData, 
		warehouseCdListToUseList, outWarehouseCdListToUseList, badWarehouseCdListToUseList,
	} = useKSK2110_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { company, userInfo } = useUserStore();
	const { printBulkLabel } = useQzPrint();

	type ProductOrderNav = { productOrderNo: string; productWorkNo?: string } | null;
	const navigationDataRef = useRef<ProductOrderNav>(null);
	const [productWorkTrigger, setProductWorkTrigger] = useState(false);

	var Inko = require('inko');
	const inko = new Inko(inkoNpmOption);
	const productOrderInfoHandleFocusId = 'inputProductOrderNo_search';

	useFetchActionbarAuth("KSK2110_R01");

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'productOrderNo',
			category: '작업지시번호',
			focusId: productOrderInfoHandleFocusId,
			responseMapping: {
				productOrderNo: 'productOrderNo',
			},
			searchFunction: async (code: string) => {
				const productOrderResponse = await getProductOrderPopupList(code, '', '', '');
				return productOrderResponse.data.data.find(value => value.productOrderNo === code);
			},
			extraFilter: () => ({
				productOrderNo: editKSK2110_R01?.productOrderNo || '',
				compCd: editKSK2110_R01?.compCd || '',
				workplaceCd: editKSK2110_R01?.workplaceCd || '',
			}),
			onAfterConfirm: () => {
				setProductWorkTrigger(true);
			},
		},
	];

	const handlePrintClick = async () => {
		if (!editKSK2110_R01 || !editKSK2110_R01.productOrderNo) {
				showWarning("출력할 생산실적번호를 선택하세요.");
				setMessage("출력할 생산실적번호를 선택하세요.");
				return;
			}
			try {
				await printKSK2110_R01(editKSK2110_R01.productOrderNo);
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			}
		};
	

	const handleExcelClick = useCallback(async () => {
		if (!editKSK2110_R01) {
			showWarning("선택된 생산실적내역이 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_KSK2110_R01('', editKSK2110_R01.productOrderNo, KSK2110_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '생산실적 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [editKSK2110_R01])

	const getParams = (filter: KSK2110_R01Filter) => {
		const params: Partial<KSK2110_R01Filter> = {
			labelPrintAuto: filter.labelPrintAuto || undefined,
		};
		return params;
	}

	// const renewalAllCount = useCallback(async () => {
	// 	const response = await getKSK2110_R01AllCount(getParams(KSK2110_R01Filter));
	// 	setAllCount(response.data.data);
	// 	return response.data.data;
	// }, [KSK2110_R01Filter, setAllCount]);

	// const fetchData = useCallback(async () => {
	// 	setLoadingSpinner(true);		
	
	// 	const responseData = (await getKSK2110_R01List(
	// 		'',
	// 		getParams(KSK2110_R01Filter),
	// 		KSK2110_R01List.length ?? 0
	// 	));


	// 	let newList = [...responseData.data.data ] as KSK2110_R01HeaderDto[];
	// 	setKSK2110_R01List(newList);

	// 	const processAllCount = await renewalAllCount();
	// 	if (newList && newList.length > 0) {
	// 		gridRefSelectedRowHandler(
	// 			gridRef,
	// 			setEditKSK2110_R01 || undefined,
	// 			() => true,// () => !responseData.find(value => value.salBillNo === selectedKSK2110_R01?.salBillNo)
	// 		);
	// 		setKSK2110_R01PastFilter(KSK2110_R01Filter);
	// 		ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
	// 	}else {
	// 		showWarning('데이터가 없습니다.');
	// 		setSelectedKSK2110_R01(undefined);
	// 		setKSK2110_R01List([]);
	// 		setKSK2110_R01LotList([]); 
	// 		setDeletedKSK2110_R01LotList([]);
	// 		setSelectedKSK2110_R01LotList([]);
	// 		setOriginalKSK2110_R01LotList([]);
	// 	}
	// 	setLoadingSpinner(false);
	// 	return responseData;
	// }, [KSK2110_R01Filter, KSK2110_R01List, setKSK2110_R01List, setKSK2110_R01PastFilter, setSelectedKSK2110_R01, selectedKSK2110_R01])

	const fetchOne = useCallback(async () => {
		if (!editKSK2110_R01?.productOrderNo) { 
			showWarning('조회할 작업지시번호를 선택하세요.'); 
			getProductWorkFieldHandlers('productOrderNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
			return; 
		}
		setLoadingSpinner(true);

		const response = await getKSK2110_R01One(editKSK2110_R01?.productOrderNo || '');
		
		if(!response.data.data) {
			showWarning('조회된 데이터가 없습니다.');
			getProductWorkFieldHandlers('productOrderNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: editKSK2110_R01?.productOrderNo } } as unknown as React.MouseEvent<HTMLInputElement>);
			setLoadingSpinner(false);
			return;
		}

		const workPlaceInfo = workPlaceList.find(value => value.workplaceCd === response.data.data?.workplaceCd);

		let logicCenter = wmsCdList.filter(value => value.minorCd === workPlaceInfo?.logicCenter)[0].minorCd;
		let defaultInWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& (value.productYn === 'Y' || value.manufactYn === 'Y' )
		);
		let defaultOutWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& (value.materialYn === 'Y' || value.manufactYn === 'Y' )
		);
		let defaultBadWarehouseCd = warehouseCdList.filter(value => value.logicCenter === logicCenter
			&& value.badYn === 'Y'
		);
		let inWarehouseCd = defaultInWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.inWarehouse));
		let outWarehouseCd = defaultOutWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.outWarehouse));
		let badWarehouseCd = defaultBadWarehouseCd.filter(value => (value.warehouseCd === workPlaceInfo?.badWarehouse));

		// console.log('작업지시정보의 logicCenter :', logicCenter);
		// console.log('작업지시정보의 inWarehouseCd :', inWarehouseCd, ' > ', '작업지시정보의 outWarehouseCd :', outWarehouseCd);

		response.data.data.logicCenter = logicCenter || wmsCdList[0]?.minorCd || '';
		response.data.data.warehouseCd = validateString(response.data.data.warehouseCd) ? response.data.data.warehouseCd : (inWarehouseCd[0]?.warehouseCd ?? '');
		response.data.data.outWarehouseCd = validateString(response.data.data.outWarehouseCd) ? response.data.data.outWarehouseCd : (outWarehouseCd[0]?.warehouseCd ?? '');
		response.data.data.badWarehouseCd = validateString(response.data.data.badWarehouseCd) ? response.data.data.badWarehouseCd : (badWarehouseCd[0]?.warehouseCd ?? '');

		const mappedHeader = mapKioskWorkTimes(response.data.data);
		setEditKSK2110_R01(mappedHeader);

		setLoadingSpinner(false);
		return mappedHeader as KSK2110_R01HeaderDto;
	}, [editKSK2110_R01, setEditKSK2110_R01, setLoadingSpinner, workPlaceList, wmsCdList, warehouseCdList]);
	

	const defaultKSK2110_R01HeaderRow = useCallback(() => {
		const logicCenter = wmsCdList[0]?.minorCd ?? '';
		const warehouseCdListToUse = warehouseCdListToUseList(logicCenter);
		const outWarehouseCdListToUse = outWarehouseCdListToUseList(logicCenter);
		const badWarehouseCdListToUse = badWarehouseCdListToUseList(logicCenter);

		const commonResult = validateCommonCodeLists([
			...buildCommonCodeRequirements(KSK2110_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				workPlaceList,
				wmsCdList,
				itemStatusList,
				warehouseCdList,
			}),
			{
				key: 'productWarehouseList',
				list: warehouseCdListToUse,
				message: KSK2020_R01_PRODUCT_WAREHOUSE_MESSAGE,
			},
			{
				key: 'outWarehouseList',
				list: outWarehouseCdListToUse,
				message: KSK2020_R01_OUT_WAREHOUSE_MESSAGE,
			},
			{
				key: 'badWarehouseList',
				list: badWarehouseCdListToUse,
				message: KSK2020_R01_BAD_WAREHOUSE_MESSAGE,
			},
		]);

		if (!commonResult.valid) {
			return {
				...defaultKSK2110_R01HeaderDto,
				inserted: true,
			};
		}

		return {
			...defaultKSK2110_R01HeaderDto,
			compCd: compCdList[0].compCd,
			workplaceCd: workPlaceList[0].workplaceCd,
			logicCenter,
			warehouseCd: warehouseCdListToUse[0].warehouseCd,
			outWarehouseCd: outWarehouseCdListToUse[0].warehouseCd,
			badWarehouseCd: badWarehouseCdListToUse[0].warehouseCd,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [
		compCdList,
		workPlaceList,
		wmsCdList,
		itemStatusList,
		warehouseCdList,
		warehouseCdListToUseList,
		outWarehouseCdListToUseList,
		badWarehouseCdListToUseList,
		validateCommonCodeLists,
	]);

	const defaultKSK2110_R01LotRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(KSK2110_R01_LOT_ROW_VALIDATE, { itemStatusList }),
		);

		if (!commonResult.valid) {
			return {
				...defaultKSK2110_R01LotDto,
				inserted: true,
			};
		}

		return {
			...defaultKSK2110_R01LotDto,
			itemStatus: itemStatusList[0].minorCd,
			inserted: true,
		};
	}, [itemStatusList, validateCommonCodeLists]);

	const defaultKSK2110_R01DetailRow = useCallback(() => ({
		...defaultKSK2110_R01DetailDto,
		inserted: true,
	}), [defaultKSK2110_R01DetailDto]);

	const defaultKSK2110_R01InspectRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(KSK2110_R01_INSPECT_ROW_VALIDATE, { faultyValueList }),
		);

		if (!commonResult.valid) {
			return {
				...defaultKSK2110_R01InspectDto,
				inserted: true,
			};
		}

		return {
			...defaultKSK2110_R01InspectDto,
			badCase: faultyValueList[0].minorCd,
			inserted: true,
		};
	}, [faultyValueList, validateCommonCodeLists]);
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedKSK2110_R01LotList();
		removeSelectedKSK2110_R01LotList();
		setEditKSK2110_R01(defaultKSK2110_R01HeaderRow());
		//라벨자동출력 옵션을 사업자정보에 있는 것과 동일하게 처리
		setKSK2110_R01Filter({ ...KSK2110_R01Filter, labelPrintAuto: company?.labelPrintAuto || 'N' });
	}, [company, defaultKSK2110_R01HeaderRow, initData, KSK2110_R01Filter, removeDeletedKSK2110_R01LotList, removeSelectedKSK2110_R01LotList, setEditKSK2110_R01, setKSK2110_R01Filter]);

	const handleDeleteClick = useCallback(() => {

		if (deletedKSK2110_R01InspectList.length > 0) {
			removeDeletedKSK2110_R01InspectList(deletedKSK2110_R01InspectList);
			removeSelectedKSK2110_R01InspectList();
			setKSK2110_R01InspectList([...KSK2110_R01InspectList]);

		} else if (selectedKSK2110_R01InspectList.length > 0) {
			addDeletedKSK2110_R01InspectList(selectedKSK2110_R01InspectList);
			removeSelectedKSK2110_R01InspectList(selectedKSK2110_R01InspectList);
		}

	}, [
		selectedKSK2110_R01InspectList, deletedKSK2110_R01InspectList, setKSK2110_R01InspectList, KSK2110_R01InspectList,
	]);
	
	const handleCreateClick = () => {
		setEditKSK2110_R01(defaultKSK2110_R01HeaderRow());

		setKSK2110_R01LotList([]);
		setDeletedKSK2110_R01LotList([]);
		setSelectedKSK2110_R01LotList([]);

		setKSK2110_R01InspectList([defaultKSK2110_R01InspectRow()]);
		setDeletedKSK2110_R01InspectList([]);
		setSelectedKSK2110_R01InspectList([]);
		setOriginalKSK2110_R01InspectList([]);
	}

	const getProductResultHeaderDto = (header: KSK2110_R01HeaderDto) => {
		console.log('header getProductResultHeaderDto :', header);
		return {
			...header,
			kpiYn: 'N',
			productEmp: header.orderEmp,
			productEmpNm: header.orderEmpNm,
			badWarehouseCd: header.badWarehouseCd,
			inspectQty: 0,
			inspectYn: 'N',
		} as KSK2110_R01ProductResultDto;
	}

	const validateInsertData = (
		header: KSK2110_R01HeaderDto,
		lotList: KSK2110_R01LotDto[],
		detailList: KSK2110_R01DetailDto[],
		inspectList: KSK2110_R01InspectDto[],
	) => {

		let warningMessage = '(지시No 조회필요)';
		
		if (!validateString(header.productOrderNo)) {
			showWarning('지시No를 입력해주세요.'); return false;
		}
		if (!validateString(header.compCd)) {
			showWarning('지시정보가 없습니다. 사업장을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.workplaceCd)) {
			showWarning('공정명을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.itemCd)) {
			showWarning('품목코드를 입력해주세요.' + warningMessage); return false;
		}
		if (!itemCdMap.has(header.itemCd)) {
			showWarning('품목코드가 존재하지 않습니다.' + warningMessage); return false;
		}
		if (!validateString(header.logicCenter)) {
			showWarning('입고물류를 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.warehouseCd)) {
			showWarning('입고창고를 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(header.orderEmp)) {
			showWarning('담당자를 입력해주세요.' + warningMessage); return false;
		}
		if (!validateEmployeeCd(header.orderEmp, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if (Number(header.productQty) + Number(header.badQty) > Number(header.orderQty)) {
			if (header.fromTime == null || header.toTime == null) {
				showWarning('생산양품량과 불량수량의 합이 지시잔량을 초과하는 경우, 작업 시작시간과 종료시간을 등록해주세요.');
				return false;
			}
		}
		// if (header.productQty > header.orderQty) {
		// 	showWarning('양품수량(lot 작업지시량)은 생산실적수량보다 클 수 없습니다.'); return false;
		// }

		let activeLotList: KSK2110_R01LotDto[] = [];
 
		// Lot 항목 검증
		if (lotList.length > 0) {
			const deletedLotListToNumber = deletedKSK2110_R01LotList.map(value => Number(value));
			activeLotList = lotList.filter(detail => 
				!deletedLotListToNumber.includes(detail.valueIndex)
			);

			// 1. lotNo가 있는 항목들만 골라냅니다.
			const lotNos = activeLotList.map(detail => detail.lotNo).filter(lotNo => lotNo); // lotNo 가져오기
			const duplicates = lotNos.filter((lot, index) => lotNos.indexOf(lot) !== index);	// lotNo 중복 제거
			
			if (duplicates.length > 0) {
				showWarning("중복된 LOT No가 있습니다.\nLOT No: " + duplicates[0]);
				return false;
			}
		}

		const validateLotList = lotList.filter(detail => 
			detail.inserted === true && detail.lotQty > 0
		);
			
		//lot 입력행이나 자재출고 수정행이 없으면 반려
		if(validateLotList.length === 0) {
			showWarning('Lot 입력행을 입력해주세요. (최소 1개 이상 입력)'); return false;
		}


		//자재출고 검증
		if (detailList.length > 0) {
			for (const detail of detailList) {
				if (detail.transportQty > detail.lotQty) {
					showWarning(`${detail.childItemcd} 품목의 출고량은 재고량보다 클 수 없습니다.`); return false;
				}
			}

			//childItemcd 기준으로 각 요소들을 분배해서 각 품목코드에 대한 출고량을 계산, 소요량과 비교해서 출고량이 소요량보다 클 수 없다
			// 현재는 수정해서 출고량이 소요량보다 높아도 되는데 롤백할 가능성이 있어서 코드를 보관함
			//
			const childItemcdList = detailList.map(detail => detail.childItemcd).filter(childItemcd => childItemcd);
			const uniqueChildItemcdList = Array.from(new Set(childItemcdList));
			for (const childItemcd of uniqueChildItemcdList) {
				const childItemcdDetailList = detailList.filter(detail => detail.childItemcd === childItemcd);
				const childItemcdTransportQty = childItemcdDetailList.reduce((sum, detail) => sum + detail.transportQty, 0);
				// if (childItemcdTransportQty > childItemcdDetailList[0].bomUsingQty) {
				// 	showWarning(`${childItemcd} 품목의 출고량은 소요량보다 클수 없습니다. `); return false;
				// }
			}
		}
		//불량사유 검증
		if (inspectList.length > 0) {
			const deletedInspectListToNumber = deletedKSK2110_R01InspectList.map(value => Number(value));
			const activeInspectList = inspectList.filter(inspect => 
				!deletedInspectListToNumber.includes(inspect.valueIndex)
			);

			// 1. badCase가 있는 항목들만 골라냅니다.
			const badCases = activeInspectList.map(detail => detail.badCase).filter(badCase => badCase);	// badCase 가져오기
			const duplicates = badCases.filter((badCase, index) => badCases.indexOf(badCase) !== index);	// badCase 중복 제거

			//불량사유 코드명 추출
			const badCaseNames = duplicates.map(badCase => faultyValueList.find(value => value.minorCd === badCase)?.codeNm);
			
			if (duplicates.length > 0) {
				showWarning("중복된 불량사유가 있습니다.\n불량사유: " + badCaseNames.join(', '));
				return false;
			}
		}
		
		return true;
	}
	
	const assignLotNoToLists = useCallback(async (currentLotList: KSK2110_R01LotDto[]) => {
		const deletedKSK2110_R01LotList_Number = deletedKSK2110_R01LotList.map(value => Number(value));

		const activeList = currentLotList.filter(lot => !deletedKSK2110_R01LotList_Number.includes(lot.valueIndex));
		const newLotList = await Promise.all(activeList.map(async (lot) => {
			let generatedLotNo = lot.lotNo;

			// API 호출하여 LotNo 생성
			const res = await createKSK2110_R01LotNo();
			if (res.data && res.data.successFlag) {
				generatedLotNo = res.data.data;
			}

			// 업데이트된 LotNo를 가진 새 객체 반환
			return {
				...lot,
				lotNo: generatedLotNo
			};
		}));
		
		// 3. 상태 업데이트
		if (newLotList.length > 0) {
			setKSK2110_R01LotList(newLotList);
		}

		return newLotList;
	}, [setKSK2110_R01LotList, deletedKSK2110_R01LotList]);
	
	const handleSaveClick = useCallback(async () => {
		setLoadingSpinner(true);
		let valid = true;
		if(!validateInsertData(editKSK2110_R01!, KSK2110_R01LotList, KSK2110_R01DetailList, KSK2110_R01InspectList)) valid = false;
		if(!valid) { setLoadingSpinner(false); return; }
		
		// STEP 0: 초기화 전에 LOT 번호 가져와서 WMS1020_R01LotMap의 각 row에 추가
		// ========================================
		const newLotList = await assignLotNoToLists(KSK2110_R01LotList);
		
		// STEP 1: 초기화 전에 미출력 라벨 데이터 추출 - 자동출력 옵션 체크
		// ========================================
		let unprintedLabelData: LabelPrintData[] = [];
		if(KSK2110_R01Filter.labelPrintAuto === 'Y') {
			const store = useKSK2110_R01Store.getState();
			unprintedLabelData = KSK2110_R01_extractUnprintedLabelData(
				store,
				deletedKSK2110_R01LotList
			);
		}

		let processName = '';
		let newHeaderList: KSK2110_R01HeaderDto[] = [];
		let newInspectList: KSK2110_R01InspectDto[] = [];
		let newDetailList: KSK2110_R01DetailDto[] = [];
		let responseData: KSK2110_R01Dto = {
			productOrderHeaderDto: editKSK2110_R01!,
			productResultHeaderDto: getProductResultHeaderDto(editKSK2110_R01!),
			wmsStockLotDtoList: newLotList,
			bomDtoList: KSK2110_R01DetailList,
			prdInspectResultDtoList: KSK2110_R01InspectList,
		};
		let deleteHeaderFlag = false;

		try {
			
		
			if (editKSK2110_R01) {

				if (newLotList.length === 0) {
					processName = 'delete';
					const deleteResponse = await deleteKSK2110_R01(editKSK2110_R01.productOrderNo);

					newHeaderList = KSK2110_R01List.filter(value => value.productOrderNo !== editKSK2110_R01.productOrderNo);

					if (deleteResponse && deleteResponse.data) {
						if (deleteResponse.data.successFlag) {
							showSuccess('생산실적 삭제가 성공하였습니다.');
							setMessage('생산실적 삭제가 성공하였습니다.');
						}else return;
					}
				} else {
					processName = 'patch';

					const deletedKSK2110_R01InspectList_Number = deletedKSK2110_R01InspectList.map(value => Number(value));
					const patchResponse = await patchKSK2110_R01({
						productOrderHeaderDto: editKSK2110_R01!,
						productResultHeaderDto: getProductResultHeaderDto(editKSK2110_R01!),
						wmsStockLotDtoList: newLotList.filter(value => (
							(value.lotQty > 0 && value.inserted === true)
						)),
						bomDtoList: KSK2110_R01DetailList,
						// 불량사유가 있는 항목만 전송
						prdInspectResultDtoList: KSK2110_R01InspectList.filter(value => (
								!deletedKSK2110_R01InspectList_Number.includes(value.valueIndex) 
								&& validateString(value.badCase)
							)
						),
					});

					responseData = patchResponse.data.data;
					

					const responseproductOrderHeaderDto = {
						...responseData.productOrderHeaderDto,
						resultQty: responseData.productOrderHeaderDto.resultQty,
						orderQty: responseData.productOrderHeaderDto.orderQty - responseData.productOrderHeaderDto.resultQty
					};

					newHeaderList = KSK2110_R01List.map(value => {
						if (value.productOrderNo === responseData.productOrderHeaderDto.productOrderNo) {
							return responseproductOrderHeaderDto;
						}
						return value;
					});
					//생산양품량이 작업지시량이랑 같거나 크면, 해당 header을 list에서 삭제
					if (editKSK2110_R01!.productQty >= editKSK2110_R01!.orderQty) {
						newHeaderList = KSK2110_R01List.filter(value => value.productOrderNo !== responseData.productOrderHeaderDto.productOrderNo);	
						deleteHeaderFlag = true;
					}
					
					if (patchResponse?.data?.data && patchResponse.data.successFlag) {

						showSuccess('생산실적이 수정되었습니다.');
						setMessage('생산실적이 수정되었습니다.');
					}else {
						// 서버 응답이 예상과 다를 경우의 에러 처리
						showWarning('생산실적 수정 후 서버로부터 올바른 데이터를 받지 못했습니다.');
						setLoadingSpinner(false);
						return;
					}
				}
			} else {
				processName = 'post';
				const postResponse = await postKSK2110_R01({
					productOrderHeaderDto: editKSK2110_R01!,
					productResultHeaderDto: getProductResultHeaderDto(editKSK2110_R01!),
					wmsStockLotDtoList: newLotList,
					bomDtoList: KSK2110_R01DetailList,
					prdInspectResultDtoList: KSK2110_R01InspectList.filter(value => (
						validateString(value.badCase)
					)),
				});
				responseData = postResponse.data.data;

				const responseproductOrderHeaderDto = {
					...responseData.productOrderHeaderDto,
					resultQty: responseData.productResultHeaderDto.productQty
				};

				newHeaderList = [
					...KSK2110_R01List,
					responseproductOrderHeaderDto,
				] as KSK2110_R01HeaderDto[];
				
				if (postResponse?.data?.data && postResponse.data.successFlag) {
					showSuccess('생산실적이 등록되었습니다.');
					setMessage('생산실적이 등록되었습니다.');
				}else {
					// 서버 응답이 예상과 다를 경우의 에러 처리
					showWarning('생산실적 등록 후 서버로부터 올바른 데이터를 받지 못했습니다.');
					setLoadingSpinner(false);
					return;
				}
			}
		} catch (error) {
			console.error("생산실적 작업 중 오류가 발생했습니다.:", error);
			// showError('생산실적 작업 중 오류가 발생했습니다.');
			setLoadingSpinner(false);
			return;
		}


		if (processName === 'delete' || deleteHeaderFlag) {
			setKSK2110_R01List(newHeaderList);

			// setSelectedKSK2110_R01(undefined);
			setEditKSK2110_R01({ ...defaultKSK2110_R01HeaderDto, })
			setKSK2110_R01DetailList([]);
			setKSK2110_R01LotList([]);

			setSelectedKSK2110_R01DetailList([]);
			setSelectedKSK2110_R01LotList([]);

			setOriginalKSK2110_R01DetailList([]);
			setOriginalKSK2110_R01LotList([]);

			setDeletedKSK2110_R01DetailList([]);
			setDeletedKSK2110_R01LotList([]);

			deleteHeaderFlag = false;

			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setKSK2110_R01List(newHeaderList);
			setKSK2110_R01LotList([]);
			insertKSK2110_R01LotList([defaultKSK2110_R01LotRow()]);

			//응답 성공했을때의 데이터의 productOrderHeaderDto는 빈곳이 많으므로, 보간해야함
			const newEditKSK2110_R01 = {
				...responseData.productOrderHeaderDto,
				orderQty: responseData.productOrderHeaderDto.orderQty - responseData.productOrderHeaderDto.resultQty,
				itemStatus: responseData.productResultHeaderDto.itemStatus || itemStatusList[0]?.minorCd || '',
				productDt: responseData.productResultHeaderDto.productDt || formatDate(new Date()),
				logicCenter: responseData.productResultHeaderDto.logicCenter || '',
				warehouseCd: responseData.productResultHeaderDto.warehouseCd || '',
				outWarehouseCd: responseData.productResultHeaderDto.outWarehouseCd || '',
				badWarehouseCd: responseData.productResultHeaderDto.badWarehouseCd || '',
				productQty: 0,
				badQty: 0,
			};

			setEditKSK2110_R01(newEditKSK2110_R01);
			setOriginalKSK2110_R01LotList(responseData.wmsStockLotDtoList);
			
			//기존 bomDetailList에서 responseData.bomDtoList에 존재하는 lotno, itemno인 행만 가져옴
			//  responseData.bomDtoList를 적용
			const newDetailList = KSK2110_R01DetailList.filter(
				value => responseData.bomDtoList.some(response => 
					response.childItemcd === value.childItemcd
					&& response.itemNo === value.itemNo
					&& response.lotNo === value.lotNo
				)
			).map(value => ({ 
				...value, 
				...responseData.bomDtoList.find(response => 
					response.childItemcd === value.childItemcd
					&& response.itemNo === value.itemNo
					&& response.lotNo === value.lotNo
				),
				childItemUsage: value.childItemUsage, 
				bomUsingQty: 0, 
				transportQty: 0, 
				isModified: false,
			}));
			setKSK2110_R01DetailList(newDetailList);
			setOriginalKSK2110_R01DetailList(newDetailList);
		}

		// setSelectedKSK2110_R01(undefined);
		setDeletedKSK2110_R01LotList([]);
		setSelectedKSK2110_R01LotList([]); // 저장 후 상세행 선택 상태 초기화
		setSelectedKSK2110_R01DetailList([]);
		
		setKSK2110_R01InspectList([defaultKSK2110_R01InspectRow()]);
		setSelectedKSK2110_R01InspectList([]);
		setDeletedKSK2110_R01InspectList([]);
		setOriginalKSK2110_R01InspectList([]);

		setTimeout(() => {
			setMessage('');
		}, 5000)
		setLoadingSpinner(false);
	
		// ========================================
		// STEP FINAL: 미출력 라벨 일괄 출력 (한 번에)
		// ========================================
		if (
			KSK2110_R01Filter.labelPrintAuto === 'Y'
			&& unprintedLabelData.length > 0 && processName !== 'delete'
		) {
			try {
				await printBulkLabel(unprintedLabelData, 'label1');
				showSuccess(`저장 완료! ${unprintedLabelData.length}개 라벨 출력`);
			} catch (error: any) {
				console.error('라벨 출력 실패:', error);
				showWarning(`저장은 완료되었으나 라벨 출력에 실패했습니다: ${error?.message || '알 수 없는 오류'}`);
			}
		}
	}, [
		KSK2110_R01Filter.labelPrintAuto,
		editKSK2110_R01,
		// selectedKSK2110_R01, 
		printBulkLabel,
		KSK2110_R01LotList,
		KSK2110_R01DetailList,
		KSK2110_R01InspectList, deletedKSK2110_R01InspectList,
		KSK2110_R01List, setKSK2110_R01List
	]);

	const getServerMessage = useCallback((error: unknown) => {
		const serverMessage = (error as AxiosError<{ message: string }>)?.response?.data?.message;
		return serverMessage || '작업종료등록 중 오류가 발생했습니다.';
	}, []);	

	//time 정보가 있고, 1900-01-01T00:00:00+09:00 과 비교해서 아닐시 false, 맞으면 true
	//1899-12-31T23:27:52+08:27:52
	const validateWorkStartEnd = useCallback((time: string | undefined) => {

		if (time === undefined) {
			return false;
		}

		// time이 문자열로 들어올 경우를 대비해 Date 객체로 변환 후 getTime 호출
		const targetDate = new Date(time);

		if (
			targetDate.getTime() !== new Date(defaultValidateDateString).getTime()
		) {
			return false;
		}
		return true;
	}, []);

	const handleWorkTimeClick = useCallback(async (productOrderNo: string, processType: KSK2110_R01WorkTimeProcessType, manualTime?: Date, rawTime?: { month: string, day: string, hour: string, minute: string }) => {
		if(!validateString(productOrderNo)) { showWarning('작업지시 번호를 입력하세요.'); return false; }

		const isReset = processType === 'workStartReset' || processType === 'workEndReset';

		if (!isReset && rawTime) {
			const m = Number(rawTime.month);
			const d = Number(rawTime.day);
			const h = Number(rawTime.hour);
			const min = Number(rawTime.minute);

			if (isNaN(m) || m < 1 || m > 12) { showWarning('월은 1~12월 사이로 입력해주세요.'); return false; }
			if (isNaN(d) || d < 1 || d > 31) { showWarning('일은 1~31일 사이로 입력해주세요.'); return false; }
			if (isNaN(h) || h < 0 || h > 23) { showWarning('시는 0~23 사이로 입력해주세요.'); return false; }
			if (isNaN(min) || min < 0 || min > 59) { showWarning('분은 0~59분 사이로 입력해주세요.'); return false; }
		}

		const isStart = processType === 'workStart' || processType === 'workStartReset';
		const timeField = isStart ? 'fromTime' : 'toTime';
		const modalType = isStart ? 'start' : 'end';
		const successMsg = isReset
			? (isStart ? '작업시작 초기화에 성공하였습니다.' : '작업종료 초기화에 성공하였습니다.')
			: (isStart ? '작업시작에 성공하였습니다.' : '작업종료에 성공하였습니다.');
		const failMsg = isReset
			? (isStart ? '작업시작 초기화에 실패하였습니다.' : '작업종료 초기화에 실패하였습니다.')
			: (isStart ? '작업시작에 실패하였습니다.' : '작업종료에 실패하였습니다.');
		const apiCall = isStart ? patchKSK2110_R01WorkStart : patchKSK2110_R01WorkEnd;

		let targetTime: Date;
		if (isReset) {
			// 초기화는 UTC 기준 Date로 생성해 JSON 직렬화 시 1900-01-01T00:00:00.000Z로 전송합니다.
			targetTime = new Date(defaultValidateDateString);
		} else if (manualTime) {
			targetTime = manualTime;
		} else {
			// 시간이 없으면 현재 로컬 시간을 사용
			targetTime = new Date();
			// targetTime.setHours(targetTime.getHours() + 9);
			if(!validateWorkStartEnd(editKSK2110_R01?.[timeField] || undefined)) {
				setWorkTimeModalType(modalType);
				setWorkTimeModalVisible(true);
				return false;
			}
		}

		try {
			const responseData = (await apiCall(productOrderNo, toLocalDateTime(targetTime))).data;
			if(responseData && responseData.successFlag) {
				showSuccess(successMsg);
				setMessage(successMsg);
				const res = responseData.data as KSK2110_R01HeaderDto;
				const nextFrom = isStart
					? (res?.workStartDt ?? res?.fromTime ?? toLocalDateTime(targetTime))
					: editKSK2110_R01!.fromTime;
				const nextTo = !isStart
					? (res?.workEndDt ?? res?.toTime ?? toLocalDateTime(targetTime))
					: editKSK2110_R01!.toTime;
				const nextProductResultNo = validateString(res?.productResultNo)
					? res.productResultNo
					: editKSK2110_R01!.productResultNo;
				if (validateString(nextProductResultNo)) {
					setNotProductResult(false);
				}
				setEditKSK2110_R01(mapKioskWorkTimes<KSK2110_R01HeaderDto>({
					...editKSK2110_R01!,
					fromTime: nextFrom,
					toTime: nextTo,
					workStartDt: isStart ? nextFrom : editKSK2110_R01!.workStartDt,
					workEndDt: !isStart ? nextTo : editKSK2110_R01!.workEndDt,
					// workStart/WorkEnd 응답 → 저장 시 productResultHeaderDto.productResultNo로 전달
					productResultNo: nextProductResultNo,
				}));
				return true;
			}else {
				showWarning(failMsg);
				return false;
			}
		} catch (error) {
			console.error(`${isStart ? '작업시작' : '작업종료'}등록 중 오류가 발생했습니다.:`, error);
			showError(getServerMessage(error));
			return false;
		}
	}, [editKSK2110_R01]);

	//헤더의 정보를 받아서 기본값이 null이 아닌 빈 문자열 값을 찾아서 시스템코드의 기본값으로 표시되게 하기
	const handleProductResultInfoCode = useCallback((headerData: KSK2110_R01HeaderDto): Partial<KSK2110_R01HeaderDto> => {
		const defaults: Partial<KSK2110_R01HeaderDto> = {};
				
		if(!validateString(headerData.compCd) && compCdList.length > 0)				defaults.compCd = compCdList[0].compCd;
		if(!validateString(headerData.workplaceCd) && workPlaceList.length > 0)		defaults.workplaceCd = workPlaceList[0].workplaceCd;

		if(!validateString(headerData.logicCenter) && wmsCdList.length > 0)			{
			defaults.logicCenter = wmsCdList[0].minorCd;
		}		
		defaults.logicCenter = headerData.logicCenter ? headerData.logicCenter : defaults.logicCenter;


		let warehouseListToUse = warehouseCdList.filter(value => (value.logicCenter === defaults.logicCenter
			&& (value.materialYn === 'Y' || value.goodsYn === 'Y' || value.productYn === 'Y' )
		));
		if(!validateString(headerData.warehouseCd) && warehouseListToUse.length > 0)	{
			defaults.warehouseCd = warehouseListToUse[0].warehouseCd;
		}

		defaults.itemStatus = validateString(headerData.itemStatus) ? headerData.itemStatus : (itemStatusList[0]?.minorCd ?? '');

		defaults.orderEmp = headerData.orderEmp ? headerData.orderEmp : (employeeCdList[0]?.empNo ?? '');
		defaults.orderEmpNm = headerData.orderEmpNm ? headerData.orderEmpNm : (employeeCdList[0]?.empNm ?? '');

		defaults.badQty = headerData.badQty ? headerData.badQty : 0;
		defaults.productQty = headerData.productQty ? headerData.productQty : 0;
	
		return defaults;
	}, [editKSK2110_R01, compCdList, workPlaceList, employeeCdList, wmsCdList, warehouseCdList])

	const handleFetchBomProductList = useCallback(async ( itemCd: string, outWarehouseCd: string, logicCenter: string ) => {
		const responseData = (await getKSK2110_R01DetailStockList(itemCd, outWarehouseCd, logicCenter)).data.data;
		if(responseData && responseData.length > 0){

			//KSK2110_R01DetailList와 responseData를 비교해서
			//lotNo, childItemcd(itemCd)가 같으면 warehouseCd, logicCenter, lotQty를 업데이트
			const currentDetailList = useKSK2110_R01Store.getState().KSK2110_R01DetailList;
			const updatedDetails = currentDetailList.map((value) => {
				const response = responseData.find(response => 
					response.lotNo === value.lotNo && response.childItemcd === value.childItemcd
				);
				return {
					...value,
					logicCenter: value.logicCenter === logicCenter ? logicCenter : wmsCdList[0].minorCd,
					lotQty: response ? response.lotQty : 0,
				}
			});

			setKSK2110_R01DetailList(updatedDetails);
		}
		setOriginalKSK2110_R01DetailList(responseData);
		detailGridRef.current?.api.ensureIndexVisible(0, 'top');
		setMessage(`상세내역 ${responseData.length}건을 조회하였습니다.`);
		setTimeout(() => setMessage(""), 5000);


	}, [editKSK2110_R01?.itemCd, editKSK2110_R01?.warehouseCd, editKSK2110_R01?.logicCenter])


	
	// input form 팝업 열기 이벤트 핸들러
	const { getFieldHandlers: getProductWorkFieldHandlers } = useInfoFormEvents({
		editData: editKSK2110_R01,
		setEditData: setEditKSK2110_R01,
		defaultData: { ...defaultKSK2110_R01HeaderDto, inserted: true },
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2110_R01'
	});

	const handleFetchLotList = useCallback(() => {
		console.log('handleFetchLotList productWorkNo:', editKSK2110_R01?.productOrderNo);
		if(!validateString(editKSK2110_R01?.productOrderNo || '')) {
			// showWarning('공정지시 번호를 입력하세요.');
			// 기존: 공정지시 팝업
			// getProductWorkFieldHandlers('productOrderNo')
			// 	.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
			// 변경: 작업지시 팝업
			getProductWorkFieldHandlers('productOrderNo')
				.onDoubleClick({ currentTarget: { blur: () => {}, value: '' } } as unknown as React.MouseEvent<HTMLInputElement>);
			return;
		}
		
		const fetchDetailList = async (itemCd: string, productQty: number, badQty: number, outWarehouseCd: string, logicCenter: string, workPlaceCd: string) => {
			try {
				const response = await getKSK2110_R01DetailList(itemCd, productQty, badQty, outWarehouseCd, logicCenter, workPlaceCd);
				
				if (response.data && response.data.successFlag === false) {
					// showWarning(response.data.message);
					setKSK2110_R01DetailList([]);
					return;
				}

				const responseData = response.data.data;
				let updatedDetailList: KSK2110_R01DetailDto[] = [];
				if(responseData && responseData.length > 0){
					updatedDetailList = responseData.map((value, idx) => ({
						...value,
						valueIndex: value.valueIndex ?? idx + 1,
						orderIndex: value.orderIndex ?? idx + 1,
						orderIndexSeq: value.orderIndexSeq ?? 0,
						lotQty: value.lotQty ?? 0,
						transportQty: 0,
						transportedQty: 0,
					}));
					setKSK2110_R01DetailList(updatedDetailList);
					setOriginalKSK2110_R01DetailList(responseData);
					detailGridRef.current?.api.ensureIndexVisible(0, 'top');
					setTimeout(() => setMessage(""), 5000);
				}else{
					// showError('상세내역이 없습니다.');
					// 자재출고 내역은 데이터가 없으면 보여주지 말기
					setKSK2110_R01DetailList([]);
				}
			} catch (error) {
				console.error(error);
				setKSK2110_R01DetailList([]);
			}
			return;
		}

		//생산결과가 있는 공정지시 정보 조회
		//공정지시번호의 작업지시번호로 생산결과 조회
		const fetchProductResult = async (headerData: KSK2110_R01HeaderDto) => {

			let apiHeaderData: KSK2110_R01ProductResultDto | null = null;
			try {
				const transportResponse = await getKSK2110_R01ProductResultList(headerData.productOrderNo!);
				apiHeaderData = transportResponse.data.data;
				
				let baseDataForDefaults;
				if (apiHeaderData && apiHeaderData.productResultNo) {
					setNotProductResult(false);
					baseDataForDefaults = { 
						...defaultKSK2110_R01HeaderDto,
						...headerData,
						...apiHeaderData,
						orderQty: headerData.orderQty - headerData.resultQty,
						productQty : 0,
						badQty : 0, // 불량수량 0 고정(초기화)
						itemStatus: apiHeaderData.itemStatus ? apiHeaderData.itemStatus : (itemStatusList[0]?.minorCd ?? ''),
					};
				} else {
					setNotProductResult(true);
					baseDataForDefaults = { 
						...defaultKSK2110_R01HeaderDto,
						...headerData,
					};
				}
				

				const defaultValues = handleProductResultInfoCode(baseDataForDefaults);

				setEditKSK2110_R01(mapKioskWorkTimes({	
					...baseDataForDefaults,
					...defaultValues,
				}));

			} catch (error) {
				console.error("ProductResult 내역 조회 실패:", error);
				setNotProductResult(true);
			}

			if(apiHeaderData && apiHeaderData.productResultNo) {
				return apiHeaderData;
			} else {
				return null;
			}
		}

		
		setKSK2110_R01LotList([]);
		setKSK2110_R01DetailList([]);
		setKSK2110_R01InspectList([]);
		setKSK2110_R01LotSearch({ ...defaultKSK2110_R01LotSearchDto, });

		const fetchAllData = async () => {
			if (validateString(editKSK2110_R01?.productOrderNo || '')) {

				const headerData = await fetchOne();
				if(!headerData) return;
				// console.log('headerData :', headerData);

				const productResult: KSK2110_R01ProductResultDto | null = await fetchProductResult(headerData);
				if(productResult && productResult.productResultNo !== '') {

					await fetchDetailList(
						productResult?.itemCd || '',
						productResult?.productQty ?? 0,
						productResult?.badQty ?? 0,
						headerData.outWarehouseCd,
						headerData.logicCenter,
						headerData.workplaceCd
					);
				}else{
					await fetchDetailList(
						headerData?.itemCd || '',
						0,
						0,
						headerData.outWarehouseCd,
						headerData.logicCenter,
						headerData.workplaceCd
					);

				}

				//  header의 창고정보, 물류정보를 정의해서 자재출고 항목에 창고정보, 물류정보를 업데이트
				if (productResult && productResult.productResultNo !== '') {

					await handleFetchBomProductList(
						productResult.itemCd,
						headerData.outWarehouseCd,
						productResult.logicCenter || (editKSK2110_R01?.logicCenter ?? wmsCdList[0].minorCd)
					);
				}
				insertKSK2110_R01LotList([defaultKSK2110_R01LotRow()]); // 소요량 계산 유도
				setKSK2110_R01InspectList([]);
				insertKSK2110_R01InspectList([defaultKSK2110_R01InspectRow()]);
			}
		};

		fetchAllData();


	}, [editKSK2110_R01])

	const handleSearchLotList = useCallback(async (lotNoInput: string) => {	

		if(!validateString(lotNoInput)) { showWarning('Lot번호를 입력해주세요'); return; }

		const lotSearchData = {
			...defaultKSK2110_R01LotSearchDto,
			...KSK2110_R01LotSearch,
			lotNo: lotNoInput,
		}
		
		const responseData = (await getKSK2110_R01LotSearch(lotSearchData));
		if(responseData && responseData.data.data) {

			const data = responseData.data.data;
			let lotQty = calculateLotQty(KSK2110_R01LotList, deletedKSK2110_R01LotList);
			setKSK2110_R01LotSearch({
				...defaultKSK2110_R01LotSearchDto,
				...data,
				lotNoInput: '',
				lotNo: data.lotNo,
				bomUsingQty: (data.bomUsingQty * lotQty || 0),
			});
		}else{
			showWarning('자재출고 lot조회 검색 결과가 없습니다.');
		}
		
		
	}, [KSK2110_R01LotSearch]);

	// KSK2010 등에서 전달받은 데이터로 자동 조회
	useEffect(() => {
		
		if (productWorkNavigationData) {
			const orderNo = productWorkNavigationData.productOrderNo
				|| productWorkNavigationData.productWorkNo
				|| '';

			navigationDataRef.current = { productOrderNo: orderNo, productWorkNo: productWorkNavigationData.productWorkNo };

			setEditKSK2110_R01({ ...editKSK2110_R01!, productOrderNo: orderNo } as KSK2110_R01HeaderDto);
			setProductWorkTrigger(true);
			
			setProductWorkNavigationData(null);
		}
	}, [productWorkNavigationData, setProductWorkNavigationData]);

	// productWorkTrigger true이면 handleFetchLotList를 호출
	useEffect(() => {
		const orderNo = navigationDataRef.current?.productOrderNo || editKSK2110_R01?.productOrderNo || '';
		if (productWorkTrigger && validateString(orderNo)) {
			handleFetchLotList();
			setProductWorkTrigger(false);
		}
	}, [productWorkTrigger]);


	
	useEffect(() => {
		if (company) {
			setKSK2110_R01Filter({ ...KSK2110_R01Filter, labelPrintAuto: company.labelPrintAuto });
		}
	}, [company, setKSK2110_R01Filter]);
	
	return {
		handlePrintClick,
		handleExcelClick,
		// fetchData,
		fetchOne,
		defaultKSK2110_R01HeaderRow,
		defaultKSK2110_R01LotRow,
		defaultKSK2110_R01DetailRow,
		defaultKSK2110_R01InspectRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		validateWorkStartEnd,
		handleWorkTimeClick,
		handleFetchBomProductList,
		getProductWorkFieldHandlers,
		handleFetchLotList,
		handleSearchLotList,
	};
}
